import { CSSObject } from '@emotion/react'

type DisplayProps = {
  [key: string]: {
    width: number
  }
}

const renderDisplayLayout: DisplayProps = {
  desktopStream: {
    width: 600,
  },
  mobileStream: {
    width: 375,
  },
}

const baseStyles = (display: string): CSSObject => ({
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
  ...renderDisplayLayout[display],
})

export { baseStyles }
